import { makeApiMutation } from "@web-monorepo/fetchers";

const useDecagonAuthTokenMutation = makeApiMutation({
  name: "decagonAuthToken",
  method: "post",
  path: "/api/marketplace/decagon/widget-token",
  useErrorBoundary: false,
});

export default useDecagonAuthTokenMutation;
